import { useAuth } from "../../context/authContext";
import { useSidebar } from "../../context/sidebarContext";
import Sidebar from "../../Sidebar";
import SubscriptionEndBadge from "../subscription/SubscriptionEndBadge";

export default function Layout({ children }) {
  const { isOpen, toggleSidebar } = useSidebar();
  const { subscription, loadingSubscription } = useAuth();

  return (
    <div className="min-h-screen flex bg-[#f2f4f8] relative">
      <Sidebar isOpen={isOpen} onClose={toggleSidebar} />
      <div className="flex flex-col flex-1 p-6 md:p-6 gap-4 md:gap-6 min-w-[240px] w-full h-screen overflow-y-auto overflow-x-hidden">
        {!subscription && !loadingSubscription && <SubscriptionEndBadge />}
        {children}
      </div>
    </div>
  );
}
